// pages/NhaVuon/index.tsx — Trang tổng hợp nhà vườn live data
import { Link } from 'react-router-dom'
import { PageHero, CtaSection, ProjectGrid, Loader } from '../../../components'
import { useProjects } from '../../../features/projects/hooks/useProjects'
import useDocumentTitle from '../../../hooks/useDocumentTitle'
import './NhaVuon.css'

const BREADCRUMBS = [
  { label: 'Trang chủ', path: '/' },
  { label: 'Công trình thiết kế', path: '/cong-trinh-thiet-ke' },
  { label: 'Nhà vườn' },
]

const NhaVuonPage = () => {
  useDocumentTitle('Nhà Vườn - MAXCONST')
  const cap4 = useProjects({
    category: 'cap4',
    pages: 10,
  })

  const tang2 = useProjects({
    category: '2tang',
    pages: 10,
  })

  const nhieuTang = useProjects({
    category: 'nhieu-tang',
    pages: 10,
  })

  const isLoading = cap4.loading || tang2.loading || nhieuTang.loading
  const globalError = cap4.error || tang2.error || nhieuTang.error

  const categories = [
    {
      title: 'Nhà Vườn Cấp 4 / Nhà Một Tầng',
      path: '/nha-vuon/nha-vuon-cap-4-nha-1-tang',
      viewAllLabel: 'Xem tất cả nhà cấp 4',
      projects: cap4.projects,
      loading: cap4.loading,
      error: cap4.error,
    },
    {
      title: 'Nhà Vườn 2 Tầng',
      path: '/nha-vuon/2-tang',
      viewAllLabel: 'Xem tất cả nhà 2 tầng',
      projects: tang2.projects,
      loading: tang2.loading,
      error: tang2.error,
    },
    {
      title: 'Nhà Vườn Nhiều Tầng',
      path: '/nha-vuon/nhieu-tang',
      viewAllLabel: 'Xem tất cả nhà nhiều tầng',
      projects: nhieuTang.projects,
      loading: nhieuTang.loading,
      error: nhieuTang.error,
    },
  ]

  return (
    <div className="nha-vuon-page">
      {/* Hero */}
      <PageHero
        tag="Thiết Kế Nhà Vườn"
        title="Thiết Kế Nhà Vườn"
        titleHighlight="Nhà Vườn"
        description="Khám phá đa dạng mẫu thiết kế nhà vườn từ cấp 4, 2 tầng đến nhiều tầng, hòa mình cùng thiên nhiên"
        breadcrumbs={BREADCRUMBS}
      />

      {/* Categories */}
      <div className="container">
        {isLoading ? (
          <div className="flex justify-center items-center py-20" style={{ minHeight: '300px' }}>
            <Loader text="Đang tải danh sách nhà vườn..." />
          </div>
        ) : globalError ? (
          <div className="error-container py-16 text-center">
            <i className="fas fa-exclamation-triangle" style={{ fontSize: '2.5rem', marginBottom: '1rem', color: 'var(--color-primary)' }} />
            <p>{globalError}</p>
          </div>
        ) : (
          categories.map((cat) => (
            <section key={cat.path} className="nha-vuon-category section-sm">
              <div className="nha-vuon-category__header">
                <h2 className="nha-vuon-category__title">
                  {cat.title}
                </h2>
                <Link to={cat.path} className="btn btn-ghost">
                  Xem tất cả <i className="fas fa-arrow-right" />
                </Link>
              </div>

              <ProjectGrid
                projects={cat.projects.slice(0, 6)}
                loading={false}
                error={null}
              />

              <div className="nha-vuon-category__footer">
                <Link to={cat.path} className="btn btn-secondary">
                  {cat.viewAllLabel} <i className="fas fa-arrow-right" />
                </Link>
              </div>
            </section>
          ))
        )}

        {/* CTA */}
        <CtaSection
          title="Bạn Cần Tư Vấn Thiết Kế Nhà Vườn?"
          titleHighlight="Thiết Kế Nhà Vườn"
          description="Liên hệ với chúng tôi để được tư vấn miễn phí và nhận báo giá chi tiết"
        />
      </div>
    </div>
  )
}

export default NhaVuonPage
